import React from "react";
import AppLanding from "./AppLanding";
import {
  Home, Building2, Building, LandPlot, Warehouse, Store, Key, Tag, Sofa, Briefcase,
} from "lucide-react";

const CHIPS = [
  { id: "1bhk",       label: "1 BHK",      query: "1 bhk",       icon: Home,      color: "#1e40af", bg: "#bfdbfe" },
  { id: "2bhk",       label: "2 BHK",      query: "2 bhk",       icon: Home,      color: "#0e7490", bg: "#a5f3fc" },
  { id: "3bhk",       label: "3 BHK",      query: "3 bhk",       icon: Building2, color: "#14532d", bg: "#bbf7d0" },
  { id: "4bhk",       label: "4+ BHK",     query: "4 bhk",       icon: Building,  color: "#7c2d12", bg: "#fed7aa" },
  { id: "villa",      label: "Villa",      query: "villa",       icon: Warehouse, color: "#78350f", bg: "#fef3c7" },
  { id: "plot",       label: "Plot",       query: "plot",        icon: LandPlot,  color: "#166534", bg: "#dcfce7" },
  { id: "rental",     label: "Rental",     query: "rent",        icon: Key,       color: "#831843", bg: "#fbcfe8" },
  { id: "sale",       label: "For Sale",   query: "sale",        icon: Tag,       color: "#7f1d1d", bg: "#fecaca" },
  { id: "furnished",  label: "Furnished",  query: "furnished",   icon: Sofa,      color: "#a16207", bg: "#fef3c7" },
  { id: "commercial", label: "Commercial", query: "commercial",  icon: Briefcase, color: "#155e75", bg: "#a5f3fc" },
];

const config = {
  appId: "gharonda",
  categories: ["Real Estate", "Interior & Furniture"],
  theme: { primary: "#0ea5e9", accent: "#0369a1" },
  hero: {
    background: "linear-gradient(135deg,#0c4a6e 0%, #0369a1 45%, #38bdf8 100%)",
    overlay: "linear-gradient(135deg, rgba(2,6,23,0.45), rgba(2,6,23,0.15))",
    badge: "Gharonda · Real Estate within the community",
    searchPlaceholder: "Search: 2 BHK, plot, rent, builder in Pune…",
  },
  chips: CHIPS,
  filterGroups: [
    {
      id: "listing_type",
      label: "Listing type",
      options: ["Sale", "Rent", "Lease", "Pre-launch", "Resale"],
    },
    {
      id: "property_type",
      label: "Property type",
      options: [
        "Apartment / Flat",
        "Villa",
        "Bungalow",
        "Plot / Land",
        "Builder Floor",
        "Penthouse",
        "Studio",
        "Row House",
        "Farm House",
        "Commercial Shop",
        "Office Space",
      ],
    },
    {
      id: "bhk",
      label: "BHK",
      options: ["1 RK", "1 BHK", "2 BHK", "3 BHK", "4 BHK", "5+ BHK"],
    },
    {
      id: "furnishing",
      label: "Furnishing",
      options: ["Furnished", "Semi-furnished", "Unfurnished"],
    },
    {
      id: "budget",
      label: "Budget",
      options: [
        "Under ₹25 L",
        "₹25 L – ₹50 L",
        "₹50 L – ₹1 Cr",
        "₹1 Cr – ₹2 Cr",
        "₹2 Cr – ₹5 Cr",
        "Above ₹5 Cr",
      ],
    },
    {
      id: "amenities",
      label: "Amenities",
      options: [
        "Parking",
        "Lift",
        "Gym",
        "Swimming Pool",
        "Clubhouse",
        "Garden",
        "Power backup",
        "Vastu-compliant",
      ],
    },
    {
      id: "service",
      label: "Services",
      options: [
        "Builder / Developer",
        "Broker / Agent",
        "Interior Designer",
        "Architect",
        "Home Loan",
        "Vastu Consultant",
        "Property Photography",
      ],
    },
  ],
};

export default function Gharonda() {
  return <AppLanding config={config} />;
}
